import React, { useEffect, useState } from "react";
import { getCustomerCategoriesService } from "../../services/categories/services";
import { useSelector } from "react-redux";
import Loading from "../loading/Loading";
import NoSpecialCategory from "../noSpecialCategory/NoSpecialCategory";
import { PERMISSION_CODE } from "../../utils/enum/enums";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";

const ClientFormCategory = ({ client, onChange, translate, readOnly }) => {
  const [categories, setCategories] = useState([]);
  const { user } = useSelector((state) => state.user);

  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleOnChangeCategory = (e) => {
    const selectedKey = e.target.value;
    onChange(selectedKey);
  };

  const getCategories = React.useCallback(async () => {
    setIsLoading(true);

    const data = await getCustomerCategoriesService({
      companyId: company?._id,
    });

    setIsLoading(false);

    if (!data || data?.code === PERMISSION_CODE.PERMISSION_DENIED) {
      setCategories([]);
      return;
    }

    setCategories(
      [
        { _id: "0", name: translate("no-selected"), key: "000" },
        ...data?.categories,
      ] ?? [],
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company?._id, userProfile?.user]);

  useEffect(() => {
    getCategories();
  }, [getCategories]);

  if (userLoading || companyLoading) return null;

  return (
    <div>
      <label className="label">{translate("select-category")}</label>
      {isLoading ? (
        <Loading key={"loading-categories"} />
      ) : (
        <>
          <select
            name="category"
            value={client.categoryId}
            onChange={handleOnChangeCategory}
            className="input"
            disabled={readOnly}
          >
            {categories.map((opt) => (
              <option key={opt.key} value={opt._id}>
                {opt.name}
              </option>
            ))}
          </select>

          {categories.length === 1 && (
            <NoSpecialCategory
              description={translate("no-categories-description-customer")}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ClientFormCategory;

/*
 [
        { key: "hl", name: translate("health") },
        { key: "nt", name: translate("nutrition") },
        { key: "tr", name: translate("tourism") },
        { key: "wf", name: translate("welfare") },
        { key: "tp", name: translate("transport") },
        { key: "sh", name: translate("shop") },
        { key: "en", name: translate("entertainment") },
        { key: "ed", name: translate("education") },
        { key: "pt", name: translate("pets") },
      ]
    : [
        { key: "gd", name: translate("good") },
        { key: "bl", name: translate("black-list") },
        { key: "cd", name: translate("cold") },
        { key: "nw", name: translate("new") },
        { key: "dm", name: translate("dormant") },
        { key: "ia", name: translate("inactive") },
        { key: "ot", name: translate("other") },
      ];
*/
